var _ellipse, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 117,
    viewBox: "0 0 138 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 103.5,
    rx: 44.5,
    ry: 8.5,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 86V80.0317C103 79.3631 102.777 78.7137 102.365 78.1865L93.76 67.1548C93.1915 66.426 92.3188 66 91.3945 66H42.6055C41.6812 66 40.8085 66.426 40.24 67.1548L31.6346 78.1865C31.2233 78.7137 31 79.3631 31 80.0317V86H54.3239H80.1831H103Z",
    fill: "#AEB8C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 33,
    width: 50,
    height: 60,
    rx: 2,
    fill: "#F5F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6001 50C58.6001 46.6864 61.2865 44 64.6001 44C67.9142 44 70.6001 46.6864 70.6001 50V59C70.6001 61.0719 68.922 62.75 66.8501 62.75C64.7782 62.75 63.1001 61.0719 63.1001 59V51.5C63.1001 50.6703 63.7704 50 64.6001 50C65.4298 50 66.1001 50.6703 66.1001 51.5V59C66.1001 59.4125 66.4376 59.75 66.8501 59.75C67.2626 59.75 67.6001 59.4125 67.6001 59V50C67.6001 48.343 66.2548 47 64.6001 47C62.9454 47 61.6001 48.343 61.6001 50V59.75C61.6001 62.6516 63.9485 65 66.8501 65C69.7517 65 72.1001 62.6516 72.1001 59.75V51.5C72.1001 50.6703 72.7704 50 73.6001 50C74.4298 50 75.1001 50.6703 75.1001 51.5V59.75C75.1001 64.3062 71.4063 68 66.8501 68C62.2938 68 58.6001 64.3062 58.6001 59.75V50Z",
    fill: "#DCE0E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79C31.4477 79 31 79.4477 31 80V103C31 104.657 32.3431 106 34 106H100C101.657 106 103 104.657 103 103V80C103 79.4477 102.552 79 102 79H85.1926C83.9981 79 82.9174 79.7087 82.4412 80.8042L80.9672 84.1958C80.4911 85.2913 79.4104 86 78.2158 86H55.9494C54.9354 86 53.99 85.4878 53.4363 84.6383L50.6482 80.3617C50.0945 79.5122 49.1491 79 48.1351 79H32Z",
    fill: "#DCE0E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAttachment);
export default __webpack_public_path__ + "static/media/empty-attachment.ee1939e75ec0952fecef01a9430794da.svg";
export { ForwardRef as ReactComponent };